var wrapper = document.createElement( 'div' );

export default function( str ) {
	if ( str && typeof str === 'string' ) {
		str = str.replace( /<\/?[^>]+>/, '' );
		wrapper.innerHTML = str;
		str = wrapper.textContent;
		wrapper.innerHTML = '';
	}

	return str;
}
